import request from '@/utils/request'

export function loginByUsername (data) {
  return request({
    url: '/personal/employee/login',
    method: 'post',
    data
  })
}

export function logout () {
  return request({
    url: '/personal/employee/logout',
    method: 'post'
  })
}

export function fetchResetPwdFirst (password) {
  const data = {
    newPassword: password
  }
  return request({
    url: '/personal/employee/resetPwdFirst',
    method: 'post',
    data
  })
}

export function getUserInfo () {
  return request({
    url: '/personal/employee/employeeInfo',
    method: 'post'
  })
}

export function getMenusList () {
  const data = {
    // web端根据系统类型获取菜单列表 mss web app interface
    systemType: 'web'
  }
  return request({
    url: '/personal/employee/getMenus',
    method: 'post',
    data
  })
}

export function modifyPwd (data) {
  return request({
    url: '/personal/employee/resetPwd',
    method: 'post',
    data
  })
}

export function sendCodeToEmail (data) {
  return request({
    url: '/personal/employee/emailValidation',
    method: 'post',
    data
  })
}

export function sendCodeToMobile (data) {
  return request({
    url: '/personal/employee/phoneValidation',
    method: 'post',
    data
  })
}

export function validationCode (data) {
  return request({
    url: '/personal/employee/validationCode',
    method: 'post',
    data
  })
}

// 忘记密码->重置密码
export function resetPwd (data) {
  return request({
    url: '/personal/employee/validationResetPwd',
    method: 'post',
    data
  })
}




// WEBPACK FOOTER //
// ./src/api/login.js